<template>
  <v-app-bar flat color="highlightedHeader">
    <div class="header-content">

      <!-- Logo- und Button-Bereich für Mobile -->
      <div v-if="isMobileDevice" class="mobile-container">
        <router-link to="/pflegegrad">
          <img height="60" :src="logoUrl" alt="Logo" class="mobile-logo" />
        </router-link>
        <v-btn
            class="white--text call-btn mobile-call-btn"
            @click="callConsultation"
            color="homeButton"
            large
        >
          <v-img src="https://www.docdorado.de/media/00/f3/eb/1695925419/icons8-telefon-100 (1).png" alt="Telefon Icon" class="call-icon" />
          Fachberatung unter: +49 172 31 32 33 5
        </v-btn>
      </div>

      <!-- Logo für Desktop -->
      <router-link to="/pflegegrad" v-if="!isMobileDevice">
        <img height="60" :src="logoUrl" alt="Logo" />
      </router-link>

      <span class="header-announcement" v-if="!isMobileDevice">Über 30.000 PFLEGEBEDÜRFTIGE vertrauen uns ihre Versorgung an!</span>

      <!-- ... Ihr anderer Code ... -->
      <v-spacer v-if="!isOnline"/>
      <v-icon v-if="!isOnline" color="error">mdi-wifi-remove</v-icon>
      <span class="ml-2 error--text" v-if="!isOnline">Kein Internet</span>
      <v-spacer />

      <v-btn v-if="!isMobileDevice"
             class="white--text call-btn"
             @click="callConsultation"
             color="homeButton"
             x-large
      >
        <v-img src="https://www.docdorado.de/media/00/f3/eb/1695925419/icons8-telefon-100 (1).png" alt="Telefon Icon" class="call-icon" />
        Fachberatung unter: +49 172 31 32 33 5
      </v-btn>

    </div>
  </v-app-bar>
</template>

<!-- ... Ihr anderer Code ... -->

<style scoped>
/* ... Ihre anderen Styles ... */

.mobile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>


<script>
import headerInfo from "@/indivconfig/headerInfo.json";
import { useOnline } from '@vueuse/core'

export default {
  methods: {
    goToLink(link) {
      window.location.href = link;
    },
    callConsultation() {
      window.location.href = "tel:+491723132335";
    },
  },
  name: 'PB-Header',
  data: () => ({
    logoUrl: headerInfo.logoUrl,
    phoneNumber: headerInfo.phoneNumber,
    homeSiteLink: headerInfo.url,
    isMobileDevice: /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }),

  computed: {
    isOnline(){
      return useOnline()?.value
    }
  }
}
</script>

<style scoped>
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 20px;
  background-color: #358f94;
}

.mobile-logo {
  height: 45px; /* Reduzierte Größe für das Logo */
  margin-bottom: 10px;
}

.header-announcement {
  font-size: 1.5em;
  font-weight: bold;
  text-decoration: underline;
  color: white;
  margin-left: 5%;
}

.mobile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.call-btn {
  font-weight: 600;
  font-size: 1em;
  letter-spacing: -0.5px;
  display: flex;
  align-items: center;
}

.call-icon {
  font-weight: 1200;
  width: 25px; /* Reduzierte Größe für das Icon */
  height: 25px;
  margin-right: 8px;
}

.mobile-call-btn {
  margin-top: 5px; /* Etwas weniger Abstand */
  font-size: 0.9em; /* Reduzierte Schriftgröße */
}


</style>
